// This file is only a template for actions.  Copy and paste this to your application's actions .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for actions is "[App Name]Actions.ts" i.e. UsersActions.ts, EntitlementActions.ts


import UserLocaleConstants from '../constants/UserLocaleConstants';
import UserLocaleServices from './../services/UserLocaleServices';
import UserLocaleStore from './../stores/UserLocaleStore';
import SystemActions from '../../../actions/SystemActions';
import SystemStore from '../../../stores/SystemStore';
import Dispatcher from '../../../flux/AppDispatcher';
var AppDispatcher = Dispatcher.get(UserLocaleConstants.LOCALE_DISPATCHER);


function receiveData(data: ILocaleData) {
    AppDispatcher.dispatch({
        actionType: UserLocaleConstants.LOCALE_GET,
        locale: data
    });
}

function sendValidationError(comp: string, error: IErrorMessageObject) {
    AppDispatcher.dispatch({
        actionType: UserLocaleConstants.LOCALE_VALIDATION_ERROR,
        messageObj: error,
        component: comp
    });
}

var UserLocaleActions = {
    getLocale(localTimeZoneName: string, callback: any, errorCallback: any, ignoreDefaultError?: boolean) {

        UserLocaleServices.getLocale(localTimeZoneName, function (data) {
            if (callback !== 'undefined' && callback != null) {
                callback();
            }
            receiveData(data);
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        }, ignoreDefaultError);
    },         

    cancelChanges() {
        AppDispatcher.dispatch({
            actionType: UserLocaleConstants.LOCALE_CANCEL_CHANGES
        });
    },

    updateLocale(localePreferences: ILocalePreferences, callback?: any, errorCallback?: any) {
        if (!SystemStore.isActionInProgress(UserLocaleConstants.LOCALE_PREFERENCES_UPDATE)) {
            SystemActions.PublicActions.beginAction(UserLocaleConstants.LOCALE_PREFERENCES_UPDATE);

            UserLocaleServices.updateLocalePreferences(localePreferences,
                () => {
                    AppDispatcher.dispatch({
                        localePreferences: localePreferences,
                        actionType: UserLocaleConstants.LOCALE_PREFERENCES_UPDATE
                    });

                    if (callback) {
                        callback();
                    }

                    SystemActions.PublicActions.endAction(UserLocaleConstants.LOCALE_PREFERENCES_UPDATE);
                },
                (error) => {
                    if (error.messageObj.propertyName) {
                        sendValidationError(UserLocaleConstants.LOCALE_MAIN_PAGE, error.messageObj);
                    }

                    if (errorCallback) {
                        errorCallback(error);
                    }

                    SystemActions.PublicActions.endAction(UserLocaleConstants.LOCALE_PREFERENCES_UPDATE);
                },
                function (error) {
                    return error.messageObj.propertyName ? true : false;
                });
        }
    }    
}

export default UserLocaleActions;